<template>
    <div class="topbar-height">
        <div class="topbar">
            <div class="wrapper">
                <div class="content-container d-flex">
                    <div class="left d-flex">
                        <div class="brand">
                            <img v-if="localeCode === 1033" src="../../../assets/new/logo/New-Logo-ShopDD-EN-1.svg"/>
                            <img v-else src="../../../assets/new/logo/New-Logo-ShopDD-TH-1.svg" />
                            <!-- <img src="@/assets/logo/logo-shopdd.svg" /> -->
                        </div>
                        <div class="signup d-flex">
                            <div class="line-wrapper d-flex">
                                <div class="line"></div>
                            </div>
                            <div class="text d-flex">
                                {{ label }}
                            </div>
                        </div>
                    </div>
                    <div class="right d-flex">
                        <div v-if="isRegister" class="text">
                            {{ lbl.topbar.dont_have_account }}
                            <span @click="goToRegister()">{{ lbl.topbar.register }}</span>
                        </div>
                        <div v-else class="text">
                            {{ lbl.topbar.have_account }}
                            <span @click="goToLogin()">{{ lbl.topbar.login }}</span>
                        </div>
                        <div class="dropdown-lang">
                            <ButtonDropdown></ButtonDropdown>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Locale from "@/helper/locale/Locale.js";
import LocaleMixin from '@/mixin/LocaleMixin.js';
import FormHelper from "@/helper/FormHelper";
import ButtonDropdown from "./ButtonDropdown/ButtonDropdown.vue";
//core
export default {
    name: "TopbarSignUp",
    mixins: [LocaleMixin],
    props: {
        label: {required: true},
        isRegister: {default: false},
    },
    components: {
        ButtonDropdown
    },
    data: function() {
        return {
            locale: Locale.getLocaleCode().toString(),
            itemList: [
                { value: '1054', text: 'ไทย' },
                { value: '1033', text: 'EN' },
            ],
            errorInfo: FormHelper.genErrorInfo(1),
            customClass: {
                margin: 'auto 0'
            },
        }
    },
    created: function() {

    },
    methods: {
        goToLogin: function(){
            this.$router.push('/login');
        },
        goToRegister: function(){
            this.$router.push('/terms');
        },
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "./TopbarSignUp.scss";
</style>
